import { useState, useEffect } from 'react';

/**
 * Subscribe to a CSS media query from React.
 *
 * Used so the product card can behave differently on phones, where a
 * card is roughly 105px wide and a row of 11px colour dots would be far
 * below a usable touch target. On narrow screens the card sends the
 * shopper to the product page to choose instead of trying to squeeze a
 * picker into the tile.
 *
 * @param {string} query e.g. '(max-width: 767px)'
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);

    setMatches(mql.matches);

    // addEventListener is not available on MediaQueryList in older Safari
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}
